import {
  Button,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import LoadingSpinner from 'components/Spinners/LoadingSpinner';
import React from 'react';

const DuplicateConfirmationDialog = ({
  openConfirmationDialog,
  setOpenConfirmationDialog,
  onConfirm,
  isUpdatingRate,
  alertMessage,
}: {
  openConfirmationDialog: boolean;
  setOpenConfirmationDialog: (open: boolean) => void;
  onConfirm: () => void;
  isUpdatingRate: boolean;
  alertMessage: string;
}) => {
  return (
    <Dialog
      open={openConfirmationDialog}
      onClose={() => setOpenConfirmationDialog(false)}
      maxWidth="sm"
      fullWidth>
      <DialogTitle>Override Existing Rate</DialogTitle>
      <Divider />
      <DialogContent>
        <Typography sx={{}}>{alertMessage}</Typography>
      </DialogContent>
      <DialogActions sx={{ marginBottom: '1rem', marginRight: '1rem' }}>
        <Stack
          spacing={1.5}
          direction="row"
          sx={{ justifyContent: 'flex-end' }}>
          <Button
            onClick={() => setOpenConfirmationDialog(false)}
            sx={{ color: colors.grey[600] }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              paddingX: '3rem',
            }}
            disabled={isUpdatingRate}
            startIcon={isUpdatingRate ? <LoadingSpinner /> : undefined}
            onClick={() => {
              onConfirm();
              setOpenConfirmationDialog(false);
            }}>
            Override Rate
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateConfirmationDialog;
